

<template>
    <!-- <el-dialog custom-class="showCmdpReaderDialog" :visible.sync="dialogCmdpReaderVisible" :width="dialogWidth"
                :title="dialogtitle" :before-close="handleClose" :close-on-press-escape="false" :close-on-click-modal="false"> -->
    <div>
       
        <!--识别出图-->
        <vxe-modal  :width="width" :title="dialogtitle" v-model="dialogVegaVisible" destroy-on-close show-zoom resize :showHeader="showHeader"
            transfer draggable :position="position" :lock-view="false" :mask="false">
            <div style="float: right;">
                <v-icon @click="dialogVegaVisible=false">mdi-close</v-icon>
            </div>
            <div :id="vegaid" style="text-align: center;" > </div>
        </vxe-modal>
    </div>
   
</template>


<script>

import * as vega from "vega";
export default {
    name: "dialogVega",
    props: {},
    components: {},
    data() {
        return {
           
            dialogVegaVisible: false,
            position:{},
           // position: { top: 10, left: document.body.clientWidth - 300 },
            ld_api_single: "/basiceg/v1/data/base/single_api?returnType=list",
            vegaDefaultConfig: {},
            vegaid:"",
            dialogtitle:"",
            width:800,
            showHeader:false

        }
    },
    methods: {
        handleClose() {
            this.pdfUrl = "";
            this.ctxUrl = "";
            this.dialogtitle = "";
            this.dialogPDFReaderVisible = false;
            this.dialogWidth = "600px";
        },
    },
    mounted() {
        
    },
    created() {
        
        // 相应弹窗通知
        this.$EventBus.$on("opendialogVega", (e) => {
            let _params = e._params;
            if (_params) {
                this.vegaDefaultConfig = _params.config ? _params.config : {};
                this.vegaid=_params.vegaid?_params.vegaid:"div1"
                this.dialogtitle=_params.dialogtitle?_params.dialogtitle:'智库'
                this.position=_params.position?_params.position:{}
                this.width=_params.width?_params.width:800,
               
                this.dialogVegaVisible = true;
                let that=this;
                this.$nextTick(()=>{
                    var view = new vega.View(vega.parse(that.vegaDefaultConfig))
                .renderer("svg")
                .initialize("#"+that.vegaid)
                .hover()
                .run();
                })
                
            }
           // this.dialogWidth = "80%";
           
          

        })
    }

}
</script>

<style lang="less" scoped>
.showCmdpReaderDialog {
    z-index: 100;
}

.nofull-tool-result {
    height: calc(100% - 10px);
}
</style>

